module.exports = __webpack_public_path__ + "media/img/rear_wheel-d44240e3.svg";